import t from "@/lang/lang";
import { Outlet } from "react-router";
import { H2 } from "@/shared/components/typography";
import { useFeatureAuth } from "@/services/backend/auth/hooks/use-feature-auth";
import { Alert403 } from "@/shared/components/alerts/alert-403";
import { BaseDataPage } from "../_components/layout/base-data-page";

export function ContactsRoute() {
  const canAccess = useFeatureAuth("gsm.contacts.basedata");
  if (!canAccess) {
    return (
      <BaseDataPage>
        <Alert403 />
      </BaseDataPage>
    );
  }

  return (
    <div>
      <H2>{t("Kontakte")}</H2>
      <div className="text-muted-foreground pt-4">
        {t(
          'Kontakte werden nicht direkt im GSM verwaltet. Die Daten werden aus MS Dynamics übernommen und kopiert wo nötig. Zur Konfiguration wie dies geschieht stehen "Kontaktarten" zur Verfügung. Zusätzlich muss für die einzelnen Dienstleistungen konfiguriert werden, welche Kontaktarten verwendet werden sollen.',
        )}
      </div>
      <div className="pt-6">
        <Outlet />
      </div>
    </div>
  );
}
